// extracted by mini-css-extract-plugin
export default {"link":"DB-z","disabled":"EB-z"};